import React from 'react';
import AbstractView from '@src/components/_views/AbstractView';
import ProductionDashboard from '@views/dashboard/ProductionDashboard';
import {EndpointUri} from '@src/@types/EndpointUri';
import {BreadcrumbItem} from '@src/@types/components/Breadcrumbs';
import SimpleLayout from '@views/dashboard/production/SimpleLayout/SimpleLayout';
import Body from '@views/dashboard/production/OrderOperationsList/Body';

export default class OrderOperationsList extends AbstractView {
    static layout = SimpleLayout;
    static pageTitle = 'Dashboards:Production.order-operations-list.page-title';

    protected static breadcrumbsItems: BreadcrumbItem[] = [
        {
            label: ProductionDashboard.pageTitle,
            uri: {route: 'dashboards@production'} as EndpointUri,
        },
        {
            label: OrderOperationsList.pageTitle,
            uri: {route: 'dashboards@production-operations-list'} as EndpointUri,
        }
    ];

    protected renderContent() {
        return <Body/>;
    }
}
